<span
  class="hts-line-status-chip"
  [class.hts-line-status-chip--validated]="isValidated"
  [class.hts-line-status-chip--passes]="isPasses"
  [class.hts-line-status-chip--needs]="isNeeds"
  nz-tooltip
  nzTooltipPlacement="top"
  [nzTooltipTitle]="isShowReason ? (reasonKey | translate : reasonParams) : null"
>
  <i *ngIf="isValidated" class="fa fa-check" aria-hidden="true"></i>
  <i *ngIf="isPasses" class="fa fa-minus-circle" aria-hidden="true"></i>
  <i *ngIf="isNeeds" class="hts-line-status-chip__dot" aria-hidden="true"></i>
  {{ labelKey | translate }}
</span>
